<template>
  <div class="red_box">
    <div class="red_container">
      <img
        src="../../assets/images/red/red_top.png"
        alt=""
        class="red_top"
      >
      <div class="top_title">
        O evento acabou
      </div>
      <div class="tip_box flex-row">
        <van-icon
          class="icon"
          name="volume"
        />
        <div class="tip">
          Lista de envelopes vermelhos:
        </div>
        <div class="marquee_box">
          <van-notice-bar scrollable>
            <template #default>
              <span>{{ marqueeText }}</span>
            </template>
          </van-notice-bar>
        </div>
      </div>
      <div class="modal">
        <div
          v-for="item in contentList"
          :key="item.title"
          class="modal_item"
        >
          <div class="title">
            <span>{{ item.title }}</span>
          </div>
          <p class="content">
            {{ item.content }}
          </p>
        </div>
        <div class="bottom">
          Welcome：{{ hostname }}
        </div>
      </div>
    </div>
    <div
      class="back"
      @click="$router.push('/')"
    >
      <van-icon
        name="wap-home"
        class="icon"
      />
      <div>Sair</div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar } from "vant";
Vue.use(NoticeBar)
export default {
  data() {
    return {
      hostname: window.location.hostname,
      marqueeList: [
        'Parabéns a kui4gp38o por conseguir dinheiro 35730.84',
        'Parabéns a md7zdhyuu por conseguir dinheiro 27953.01',
        'Parabéns a x7jmrziu5 por conseguir dinheiro 52334.54',
        'Parabéns a nhfrtul6b por conseguir dinheiro 43209.34',
        'Parabéns a kvvj7j4km por conseguir dinheiro 14628.41',
        'Parabéns a subhezxan por conseguir dinheiro 39448.26',
        'Parabéns a kggga5878 por conseguir dinheiro 20445.43',
        'Parabéns a g50gfhq76 por conseguir dinheiro 9688.91',
        'Parabéns a h6u85spht por conseguir dinheiro 13050.71',
        'Parabéns a mhjduab45 por conseguir dinheiro 24711.55',
        'Parabéns a phk1w8n28 por conseguir dinheiro 16359.58',
        'Parabéns a yfrqxigz7 por conseguir dinheiro 1120.27',
        'Parabéns a rdok768xz por conseguir dinheiro 48357.84',
        'Parabéns a suipqk9zd por conseguir dinheiro 53490.43',
        'Parabéns a l4x9hh49y por conseguir dinheiro 21996.78',
        'Parabéns a pzo3s4x77 por conseguir dinheiro 1821.09',
        'Parabéns a cdr8lposc por conseguir dinheiro 49371.23',
        'Parabéns a dogp5gyc9 por conseguir dinheiro 33247.06',
        'Parabéns a dbncch488 por conseguir dinheiro 21903.37',
        'Parabéns a gnct5jp0u por conseguir dinheiro 46843.74',
      ],
      contentList: [
        {
          title: 'Atividades',
          content: 'Atividades Para agradecer aos membros pelo apoio e confiança nesta plataforma, não temos desejos falsos ou atividades não criativas. Só reembolsaremos você com dinheiro real! A partir de agora, desde que você faça transferências diárias, recarregue online e complete a primeira recarga diária, todos os associados no dia seguinte poderão participar da premiação de envelopes vermelhos, com o maior bônus, e sempre boa sorte. Esteja com você!'
        },
        {
          title: 'Tempo de atividade, objeto',
          content: 'Tempo de atividade, objeto A partir de agora, todos os associados válidos que completaram a recarga poderão usufruir deste evento. O horário de funcionamento é :02:00--02:59 06:00:--06:59 10:00--10:59 14:00--14:59 18:00--18:59 22:00-22:59)'
        },
        {
          title: 'Condições de participação',
          content: 'Os eventos são calculados no horário brasileiro. Por exemplo, para se qualificar para o sorteio de 2 de janeiro, você precisa concluir o depósito em 1º de janeiro.'
        },
        {
          title: 'Configurações de prêmios',
          content: 'Cada vez que você completar uma recarga de 10, 20, 30, 40, 50, você terá uma oportunidade de sorteio'
        },
        {
          title: 'Regras de atividade do envelope vermelho',
          content: '1. Cada membro só pode ter uma conta de membro válida. Se for constatado que o membro registrou várias contas sob o mesmo IP para apostar e pegar envelopes vermelhos, a empresa tem o direito de recusar a entrega do bônus e congelar a conta para garantir os interesses dos jogadores normais. \n2. Para garantir a autenticidade das informações de registro do membro, o número do cartão bancário e outras informações não devem ser modificados quando o primeiro pagamento for feito após a solicitação bem-sucedida do bônus, caso contrário, o desconto e o lucro do período serão deduzidos.\n3. Esta atividade é executada automaticamente pelo programa do sistema da plataforma. A probabilidade de ganhar segue completamente a mecânica e a probabilidade natural e não envolve qualquer operação manual. A atividade lotérica está sujeita ao julgamento do sistema e não pode ser contestada.\n4. Durante o período de atividade, a plataforma implementará rigorosamente as regras sobre abuso de contas pessoais por parte dos membros. A empresa reserva-se o direito de encerrar o login do membro ou cancelar a qualificação do desconto a qualquer momento.\n5. A empresa reserva-se o direito de não recompensar qualquer membro que colete descontos ilegalmente ou registre uma conta ou faça depósitos maliciosos.\n6. A plataforma reserva-se o direito de alterar, interromper ou cancelar atividades promocionais a qualquer momento sem aviso prévio.\n7. A participação nesta promoção significa que você leu e concordou detalhadamente com a série de termos da "Declaração do Evento" no site. A fim de evitar diferenças de compreensão do texto, a plataforma reserva-se o direito final de interpretar o evento; aplicável a todas as promoções.'
        },
      ]
    }
  },
  computed: {
    marqueeText() {
      return this.marqueeList.join('  ')
    }
  },
  mouted() {
    console.log(this.$parent.act_active)
    if (this.$route.query.index) {
      this.$parent.act_active = 6;
    } else {
      this.$parent.isShowBottom = false;
    }
  }
}
</script>
<style scoped lang="less">
.flex-row {
  display: flex;
  align-items: center;
}

.red_box {
  background-image: url(../../assets/images/red/red_bg.png);
  width: 100%;
  background-size: cover;
  min-height: 100vh;

  .red_container {
    width: 90%;
    margin: 0 auto;
  }

  .red_top {
    margin-top: 20px;
    width: 100%;
  }

  .top_title {
    color: #ffe349;
    font-size: 28px;
    text-align: center;
  }

  .tip_box {
    margin-top: 12px;
    padding: 4px 10px;
    color: #ffffff;
    font-size: 14px;
    border-radius: 20px;
    background-color: rgba(0, 0, 0, 0.25);

    .icon {
      margin-right: 2px;
    }

    .marquee_box {
      flex: 1;

      /deep/ .van-notice-bar {
        padding-right: 0;
        padding-left: 5px;
        background-color: transparent;
        height: 20px;
        line-height: 1;

        span {
          color: #f5c630;
        }
      }
    }
  }

  .modal {
    width: 100%;
    padding: 10px;
    margin-top: 20px;
    background-image: url(../../assets/images/red/modal_bg.png);
    background-size: 100%;
    box-sizing: border-box;

    .modal_item:last-child {
      .content {
        font-size: 14px;
        line-height: 28px;
      }
    }

    .title {
      font-weight: 700;
      font-size: 14px;
      width: 181%;
      height: 26px;
      line-height: 26px;
      margin-top: 20px;

      span {
        color: #450c18;
        display: inline-block;
        min-width: 70px;
        padding: 0 20px;
        text-align: center;
        background-image: url(../../assets/images/red/title_bg.png);
        background-size: 100% 100%;
      }
    }

    .content {
      font-size: 13px;
      margin-top: 20px;
      color: #ffffff;
      line-height: 20px;
      padding-left: 1em;
      white-space: pre-wrap;
    }
  }

  .bottom {
    text-align: center;
    font-family: PingFang SC;
    font-weight: 600;
    font-style: italic;
    text-decoration: underline;
    color: #fff;
  }

  .back {
    position: fixed;
    top: 3px;
    left: 3px;
    z-index: 2024;
    border-radius: 100%;
    background: rgba(0, 0, 0, .3);
    border: 1px solid #fff;
    color: #fff;
    font-size: 11px;
    width: 50px;
    height: 50px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .icon {
      font-size: 22px;
      margin-bottom: 2px;
    }
  }
}
</style>